function closeCartTool(element) {
  const popup = element.closest('.popup-toolDown');
  if (!popup) return;
  const scope = popup.closest('#halo-cart-sidebar') || document;
  popup.classList.remove('show');
  scope.querySelector('.previewCart')?.classList.remove('active-tool');
  scope.querySelector(`[data-popup="${popup.id}"]`)?.focus();
}

class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.currentTarget.dataset.popup;
        const scope = this.closest('#halo-cart-sidebar') || document;
        const popup = scope.querySelector(`#${id}`);
        if (!popup) return;
        scope.querySelectorAll('.popup-toolDown.show').forEach((open) => open.classList.remove('show'));
        popup.classList.add('show');
        scope.querySelector('.previewCart')?.classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      const note = this.closest('.popup-toolDown')?.querySelector('textarea[name="note"]');
      if (note) note.value = note.defaultValue;
      closeCartTool(this);
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', async (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      const button = event.currentTarget;
      button.disabled = true;
      try {
        const response = await fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
        if (!response.ok) throw new Error('Cart note update failed');
        this.querySelector('.text-area').defaultValue = this.val;
        closeCartTool(this);
      } catch (error) {
        console.warn('Cart note was not saved', error);
      } finally {
        button.disabled = false;
      }
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
            Shopify.getCart((cart) => {window.sharedFunctions?.updateSidebarCart(cart)});
          });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('coupon-code', CouponCode);

(function () {
  function bindCartFocusReturn() {
    const sidebar = document.getElementById('halo-cart-sidebar');
    if (!sidebar || sidebar.dataset.pukoCartFocusReturn === 'true') return;
    sidebar.dataset.pukoCartFocusReturn = 'true';
    let opener = null;
    let wasOpen = document.body.classList.contains('cart-sidebar-show');
    document.addEventListener('click', (event) => {
      const target = event.target.closest?.('[data-cart-sidebar]');
      if (target && target.getClientRects().length) opener = target;
    }, true);
    document.addEventListener('keyup', (event) => {
      if (event.key !== 'Escape' || event.defaultPrevented || !document.body.classList.contains('cart-sidebar-show') || sidebar.querySelector('.popup-toolDown.show') || document.body.classList.contains('newsletter-show')) return;
      const close = sidebar.querySelector('[data-close-cart-sidebar]');
      if (!close || !close.getClientRects().length) return;
      event.preventDefault();
      close.click();
    });
    new MutationObserver(() => {
      const isOpen = document.body.classList.contains('cart-sidebar-show');
      if (wasOpen && !isOpen) {
        if (opener?.isConnected && opener.getClientRects().length) {
          const active = document.activeElement;
          if (active === document.body || sidebar.contains(active) || active === opener) {
            opener.focus({preventScroll: true});
          }
        }
        opener = null;
      }
      wasOpen = isOpen;
    }).observe(document.body, {attributes: true, attributeFilter: ['class']});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCartFocusReturn, {once: true});
  } else {
    bindCartFocusReturn();
  }
})();

